import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskCustomerPermissionsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-customer-permissions',
	path: '/jira/servicedesk/projects/:projectKey/settings/customer-permissions',
	exact: true,
};
